/* eslint-disable import/no-anonymous-default-export */
export default {
  baseurl: "https://consultify.netwave-tech.com/api/",
  baseurlFront: "https://consultify.dev-bt.xyz/",
  DocumentUrl: "https://consultify.netwave-tech.com/api//",
};

